import {
    DEFAULT_MAP_TEXT_LABEL_FONT_FAMILY,
    type MapTextLabelFontFamily,
} from "@west-marches/shared";

export interface TextLabelFontOption {
  id: MapTextLabelFontFamily;
  label: string;
  family: string;
  sample: string;
  note: string;
  usage: "ui" | "map";
}

export const TEXT_LABEL_FONT_OPTIONS: readonly TextLabelFontOption[] = [
  {
    id: "classic",
    label: "Classic",
    family: "'Segoe UI', system-ui, -apple-system, sans-serif",
    sample: "Point of Interest",
    note: "System UI text used for controls, panels, and readable interface copy",
    usage: "ui",
  },
  {
    id: "fondamento",
    label: "Fondamento",
    family: "'Fondamento', 'Palatino Linotype', serif",
    sample: "The Shrouded Marches",
    note: "Final handwritten map font for region names, cities, landmarks, and notes",
    usage: "map",
  },
] as const;

export const MAP_TEXT_LABEL_FONT_OPTIONS = TEXT_LABEL_FONT_OPTIONS.filter(
  (option) => option.usage === "map",
) as readonly TextLabelFontOption[];

export const UI_TEXT_LABEL_FONT_OPTIONS = TEXT_LABEL_FONT_OPTIONS.filter(
  (option) => option.usage === "ui",
) as readonly TextLabelFontOption[];

export const TEXT_LABEL_FONT_OPTIONS_BY_ID = Object.fromEntries(
  TEXT_LABEL_FONT_OPTIONS.map((option) => [option.id, option]),
) as Record<MapTextLabelFontFamily, TextLabelFontOption>;

export function resolveTextLabelFontStack(fontFamily: MapTextLabelFontFamily | undefined): string {
  return TEXT_LABEL_FONT_OPTIONS_BY_ID[fontFamily ?? DEFAULT_MAP_TEXT_LABEL_FONT_FAMILY]?.family
    ?? TEXT_LABEL_FONT_OPTIONS_BY_ID[DEFAULT_MAP_TEXT_LABEL_FONT_FAMILY].family;
}
